export default {"src":"/_next/static/media/nothing-found.81fd1170.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};